import * as bootstrap from 'bootstrap';
import { cookies } from "./cookies.class";


document.addEventListener("DOMContentLoaded", function () {
    const cookiesBanner = document.querySelector('#cookies-message');
    const acceptCookiesBtn = document.querySelector('#accept-cookies-checkbox');

    if (!cookiesBanner || !acceptCookiesBtn) return;

    // Sprawdzenie, czy użytkownik już zaakceptował cookies
    if (cookies.get('accept-cookies') !== '1') {
        cookiesBanner.style.display = "block"; // Pokaż baner
    }

    // Obsługa kliknięcia w "Chcę ciastko"
    acceptCookiesBtn.addEventListener('click', function (event) {
        event.preventDefault();
        cookies.set('accept-cookies', '1', 30);
        cookiesBanner.style.display = "none";
    });
});
